//@ts-nocheck
import React, { useEffect } from 'react';
import styled from "styled-components";
import * as d3 from 'd3';
import { gray, blue, green, orange, other, deleteECRReportImage, exportECRChart, filterECRHeading_AndComparison, compareMeasure, createStackedChart_NoComparison, createStackedChart_Comparison } from "./elements/helpers";
import { Heading3, ReportText } from '../../Common/SharedStyledComponents';


const POEChart = ({
    poeData,
    poeData_2,
    parentWidth,
    EarlyCareerReportState,
    report_display_id,
    currentDateTime,
    university,
    start_year,
    end_year,
    vintage
}) => {
    useEffect(() => {
        d3.select("#POEChart svg").remove();
        d3.select("#POEChart .ecr_tooltip").remove();
        deleteECRReportImage("poe-chart.png", currentDateTime, report_display_id, vintage);

        const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
        if ((compare_measure == 0 && poeData && poeData.length > 0) ||
            (compare_measure > 0 && poeData && poeData_2 && poeData.length > 0 && poeData_2.length > 0)) {

            const subgroups = ["avg_poe_pi", "avg_poe_not_pi"];
            const colors = [blue, gray]
            if (compare_measure == 0) {                
                createStackedChart_NoComparison(
                    "#POEChart",
                    parentWidth,
                    poeData,
                    subgroups,
                    "poe_label",
                    "poe_pct",
                    "Percentage of Effort",
                    colors
                );
            }
            else {
                if (poeData_2 && poeData_2.length > 0) {
                    createStackedChart_Comparison(
                        "#POEChart",
                        parentWidth,
                        poeData,
                        poeData_2,
                        compare_measure,
                        subgroups,
                        "poe_label",
                        "poe_pct",
                        "Percentage of Effort",
                        colors
                    );
                }
            }
            exportECRChart("#POEChart", "poe-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "no", vintage)
        }

    }, [poeData, poeData_2, parentWidth])

    const subHeading = filterECRHeading_AndComparison(EarlyCareerReportState.EarlyCareerReportFilterSavedValues, EarlyCareerReportState.Suborgs);
    const compare_measure = compareMeasure(EarlyCareerReportState.EarlyCareerReportFilterSavedValues);
    return (
        <div className="ChartComponent">
            <div id="chartPOE">
                <Heading3 bold italic>Percentage of Research Effort as PI, {university} Faculty</Heading3>
                <Heading3 italic>{subHeading}</Heading3>
                {((compare_measure == 0 && poeData?.length >= 0) || (compare_measure > 0 && (poeData?.length > 0 && poeData_2?.length > 0))) && <div id="POEChart"></div>}
                {(poeData?.length == 0 || (compare_measure > 0 && (poeData?.length == 0 || poeData_2?.length == 0))) && <p className="no_data_text">This visualization is unavailable because your institution does not provide data on researcher percentage of effort.</p>}
                <ReportText>
                    This chart shows the percentage of effort faculty members dedicate to grants on which they are principal investigators, as opposed to grants on which they serve in other roles such as co-investigator. “Data Year” refers to the number of years a cohort of faculty members has appeared in the IRIS-UMETRICS dataset of researchers paid on sponsored grants. Data from {start_year} to {end_year} were used to build these cohorts.
                </ReportText>                
            </div>
            <a className="export" onClick={() => exportECRChart("#chartPOE", "poe-chart.png", EarlyCareerReportState, report_display_id, currentDateTime, "yes", vintage)}><i className="fa fas fa-download ecr_export"></i>Export Chart</a>
        </div>
    );
}

/**
 * Styled div to shrink graph titles
 * */
export const TitleDiv = styled.div`
    width: 75%;
    margin-inline: auto;
`;

export default POEChart;